import React from 'react';
import SafeIcon from '../common/SafeIcon';

const ImagePlaceholder = ({ label, className = "", icon = "Image" }) => {
  return (
    <div className={`flex flex-col items-center justify-center bg-slate-200 border-2 border-dashed border-slate-300 text-slate-500 rounded-2xl overflow-hidden relative ${className}`}>
      <div className="absolute inset-0 bg-slate-100 opacity-50"></div>
      <div className="relative z-10 flex flex-col items-center p-6 text-center">
        <SafeIcon name={icon} className="w-10 h-10 mb-3 text-slate-400" />
        <span className="text-sm md:text-base font-medium tracking-wide">{label}</span>
        <span className="text-xs text-slate-400 mt-1 uppercase tracking-wider">Placeholder</span>
      </div>
    </div>
  );
};

export default ImagePlaceholder;